module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"departmentSite":"Strona oddziału"},"en":{"departmentSite":"Branch page"}}')
  delete Component.options._Ctor
}
